// Game-module shim (unify Phase 3): resolves to the active game's DraftBoard.
// Conditional require so only the active game's module tree is evaluated.
import game from '../games';
const impl = game.id === 'mlbb'
  ? require('../games/mlbb/components/DraftBoard')
  : require('../games/dota/components/DraftBoard');
export default impl.default;
